export default {"src":"/_next/static/media/gif-svgrepo-com.03a47728.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};